<ul>
  @for (menuItem of menu; track menuItem.label) {
    <li>
      <a [class.disabled]="menuItem.hasAccess === false" [href]="menuItem.link" target="_blank">
        <div [innerHtml]="safeHtml(menuItem.label)" [class.no-access]="!menuItem.hasAccess"></div>
      </a>
    </li>
  }
</ul>
